// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__nlASx","pageWrapper":"App_pageWrapper__X3Vkc","contentBox":"App_contentBox__pfqbs","modalWrapper":"App_modalWrapper__CguEJ"};